import React, { Component } from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { Card, CardBody, CardHeader, Progress } from 'reactstrap';
import LoadingOverlay from './LoadingOverlay';

const PROJECT_PROGRESS_QUERY = gql`
  query StatsProjectProgress {
    projectProgress: stats_project_progress {
      projectId: project_id
      projectName: project_name
      weldingLength: welding_length
      weldingComplete: welding_complete
      progress
    }
  }
`;

class WeldingProgressChart extends Component {
  render() {
    return (
      <Query query={PROJECT_PROGRESS_QUERY}>
        {({ loading, error, data }) => (
          <Card>
            <CardHeader>
              <strong>Welding Progress</strong>
            </CardHeader>
            <CardBody style={{ position: 'relative', minHeight: '150px' }}>
              {loading && <LoadingOverlay />}
              {error && <div>Error: {error.message}</div>}
              {!loading && !error && data && data.projectProgress.map((project, idx) => (
                  <div key={idx} className="mb-4">
                    <h6>{project.projectName}</h6>
                    <div className="mb-2">
                      <div className="clearfix mb-1">
                        <span className="float-left">Welding</span>
                        <span className="float-right">{project.progress}%</span>
                      </div>
                      <Progress value={project.progress} color="success" />
                      <small className="text-muted">
                        {project.weldingComplete} / {project.weldingLength} ({project.weldingLength - project.weldingComplete} remaining)
                      </small>
                    </div>
                  </div>
              ))}
            </CardBody>
          </Card>
        )}
      </Query>
    );
  }
}

export default WeldingProgressChart;



// WEBPACK FOOTER //
// ./src/views/Dashboard/WeldingProgressChart.js